import React from 'react'

const Home = () => (
  <div>
    <h1 className="home-greeting">Hello!</h1>
  </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/routes/Home.js